<template>
  <div>
    <TheHeader />
    <section v-if="relData.codsocio" id="relcontainer">
      <div class="container pb-5">
        <div class="row">
          <div class="col-12 py-4">
            <router-link
              class="btn-voltar d-print-none"
              :to="{ name: 'chequegarantido' }"
            >
              <span class="material-icons">chevron_left</span> Relatórios
              Garantia de Cheques
            </router-link>
            <h1 class="title mt-4 text-uppercase">
              Demonstrativo de faturamento Garantia de Cheques
            </h1>
          </div>
        </div>

        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <div class="rel-title">Fatura</div>
            <div class="rel-value">{{ relData.fatura }}</div>
          </div>
          <div class="col-md-6 mt-3 mt-md-0 text-md-right d-print-none">
            <button
              type="button"
              class="btn btn-outline-danger mr-1 font-weight-bold"
              @click="printPage"
            >
              BAIXAR PDF
              <IconPdf class="ml-2" width="15" heigth="15" />
            </button>
            <div class="dropdown d-inline-flex">
              <button
                class="btn btn-outline-success font-weight-bold ml-1"
                type="button"
                id="dropdownXls"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                BAIXAR EXCEL
                <IconXls class="ml-2" width="15" heigth="15" />
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownXls"
              >
                <button
                  class="dropdown-item"
                  type="button"
                  @click="exportTableToCSV('cheque_garantido')"
                >
                  Garantia de Cheques
                </button>
                <button
                  class="dropdown-item"
                  type="button"
                  @click="exportTableToCSV('cheque_ressarcido')"
                >
                  Cheque Ressarcido
                </button>
                <button
                  class="dropdown-item"
                  type="button"
                  @click="exportTableToCSV('cheque_recuperacao')"
                >
                  Cheque Recuperação
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded p-4 mt-4 border border-light">
          <div class="row">
            <div class="col-12">
              <div class="rel-title">ENTIDADE</div>
              <div class="rel-value-reg">{{ relData.entidade }}</div>
            </div>
            <div class="col-md-4 mt-4">
              <div class="rel-title">ASSOCIADO</div>
              <div class="rel-value-reg">{{ relData.codsocio }}</div>
            </div>
            <div class="col-md-2 mt-4">
              <div class="rel-title">SÓCIO DESDE</div>
              <div class="rel-value-reg">{{ relData.dtfiliacao }}</div>
            </div>
            <div class="col-md-6 mt-4">
              <div class="rel-title">ENDEREÇO</div>
              <div class="rel-value-reg">{{ relData.endereco }}</div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded p-4 mt-4 border border-light">
          <div class="row">
            <div class="col-md-3">
              <div class="rel-title">Valor mínimo contratado</div>
              <div class="rel-value-reg">{{ relData.valminimo }}</div>
            </div>
            <div class="col-md-3 text-left text-md-center mt-4 mt-md-0">
              <div class="rel-title">Taxa Mínima</div>
              <div class="rel-value-reg">{{ relData.taxaminima }}</div>
            </div>
            <div class="col-md-3 text-left text-md-right mt-4 mt-md-0">
              <div class="rel-title">Emissão</div>
              <div class="rel-value-reg">{{ relData.emissao }}</div>
            </div>
            <div class="col-md-3 text-left text-md-right mt-4 mt-md-0">
              <div class="rel-title">Vencimento</div>
              <div class="rel-value-reg">{{ relData.dtvencti }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-4 mt-4"
            v-for="(item, index) in itemsTop"
            :key="index"
          >
            <ItemCard
              ref="itemCard"
              :title="item.titulo"
              :value="String(item.valor)"
            />
          </div>
        </div>

        <div class="bg-white rounded p-4 mt-4 border border-light">
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex flex-column justify-content-between h-100">
                <div>
                  <div class="rel-value">Crédito Entidade</div>
                  <ul class="list-group list-group-flush mt-2">
                    <li
                      class="list-group-item d-flex justify-content-between px-0"
                      v-for="(item, index) in relData.creditoentidade"
                      :key="index"
                    >
                      <div class="field">{{ item.descricao }}</div>
                      <div class="value">{{ item.valor | currency }}</div>
                    </li>
                  </ul>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between pt-3 border-top"
                >
                  <div>Total</div>
                  <div class="rel-value">
                    {{ totalCredEntidade | currency }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-5 mt-md-0">
              <div class="d-flex flex-column justify-content-between h-100">
                <div>
                  <div class="rel-value">Crédito Associado</div>
                  <ul class="list-group list-group-flush mt-2">
                    <li
                      class="list-group-item d-flex justify-content-between px-0"
                      v-for="(item, index) in relData.creditoassociado"
                      :key="index"
                    >
                      <div class="field">{{ item.descricao }}</div>
                      <div class="value">{{ item.valor | currency }}</div>
                    </li>
                  </ul>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between pt-3 border-top"
                >
                  <div>Total</div>
                  <div>
                    <strong>{{ totalCredAssociado | currency }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="total text-center pt-5 pb-3">
            <div class="rel-title">TOTAL DA FATURA</div>
            <div class="rel-value">{{ totalFatura | currency }}</div>
          </div>
        </div>

        <div class="row">
          <div
            v-for="(item, index) in relData.operacoesnomes"
            :key="index"
            class="col mt-4"
            :class="
              index == 0
                ? 'first'
                : index == relData.operacoesnomes.length - 1
                ? 'last'
                : 'other'
            "
          >
            <ItemCard
              ref="itemCard"
              :title="item.descricao"
              :value="String(item.quantidade)"
              :subtitle="'Total'"
              :subvalue="item.valor | currency"
            />
          </div>
        </div>

        <div
          class="mt-4 bg-white rounded p-4 border border-light d-flex flex-column flex-md-row justify-content-left"
        >
          <div class="d-flex align-items-center">
            <div class="rel-title mb-0" style="font-size: 12px">
              RISCO EVITADO
            </div>
            <div class="rel-value ml-3" style="font-size: 14px">
              R$ {{ relData.valrisc }}
            </div>
          </div>
          <div
            class="d-flex align-items-center ml-0 ml-md-5 pl-md-2 mt-3 mt-md-0"
          >
            <div class="rel-title mb-0" style="font-size: 12px">
              RISCO EVITADO
            </div>
            <div class="rel-value ml-3" style="font-size: 14px">
              {{ relData.percrisc }}
            </div>
          </div>
        </div>

        <div class="mt-5">
          <h3 class="subtitle">CHEQUES RESSARCIDOS</h3>
          <List
            class="bg-white rounded pt-3 px-3 mt-3 w-100"
            :items="relData.ressarcido"
          />
        </div>

        <div class="mt-5">
          <h3 class="subtitle">CHEQUES RECUPERADOS</h3>
          <List
            class="bg-white rounded pt-3 px-3 mt-3 w-100"
            :items="relData.recuperacao"
          />
        </div>
      </div>

      <!-- TABLE PARA CRIAÇÃO DO XLS -->
      <div v-show="0">
        <table id="cheque_garantido">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Desc</th>
              <th scope="col">Filiação</th>
              <th scope="col">Vencimento</th>
              <th scope="col">Tax. Min</th>
              <th scope="col">Val. Min</th>
              <th scope="col">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in relData.creditoentidade" :key="index">
              <td>{{ item.descricao }}</td>
              <td>{{ relData.dtfiliacao }}</td>
              <td>{{ relData.dtvencti }}</td>
              <td>{{ relData.taxaminima | currency }}</td>
              <td>{{ relData.valminimo | currency }}</td>
              <td>{{ item.valor | currency }}</td>
            </tr>
          </tbody>
        </table>
        <table id="cheque_ressarcido">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Agência</th>
              <th scope="col">Autorização</th>
              <th scope="col">Banco</th>
              <th scope="col">Cheque</th>
              <th scope="col">Documento</th>
              <th scope="col">Val. Cheque</th>
              <th scope="col">Val. Garantido</th>
              <th scope="col">Val. Ressarcido</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in relData.ressarcido" :key="index">
              <th scope="row">{{ item.agencia }}</th>
              <td>{{ item.autoriz }}</td>
              <td>{{ item.banco }}</td>
              <td>{{ item.cheque }}</td>
              <td>{{ item.documento }}</td>
              <td>{{ item.vlrcheque | currency }}</td>
              <td>{{ item.vlrgarantido | currency }}</td>
              <td>{{ item.vlrressarcido | currency }}</td>
            </tr>
          </tbody>
        </table>
        <table id="cheque_recuperacao">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Agência</th>
              <th scope="col">Autorização</th>
              <th scope="col">Banco</th>
              <th scope="col">Cheque</th>
              <th scope="col">Documento</th>
              <th scope="col">Val. Cheque</th>
              <th scope="col">Val. Recuperado</th>
              <th scope="col">Val. Ressarcido</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in relData.recuperacao" :key="index">
              <th scope="row">{{ item.agencia }}</th>
              <td>{{ item.autoriz }}</td>
              <td>{{ item.banco }}</td>
              <td>{{ item.cheque }}</td>
              <td>{{ item.documento }}</td>
              <td>{{ item.vlrcheque | currency }}</td>
              <td>{{ item.vlrrecuperado | currency }}</td>
              <td>{{ item.vlrressarcido | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section v-else>
      <loading />
    </section>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import tableexport from "tableexport";
import ItemCard from "@/components/relatorio/ItemCard";
import List from "@/components/relatorio/List";
import IconPdf from "@/components/icones/Pdf";
import IconXls from "@/components/icones/Xls";
// eslint-disable-next-line no-unused-vars
import { formata } from "../../helpers";
export default {
  name: "demonstrativo-faturamento",
  data() {
    return {
      total: 0,
      totalCredEntidade: 0,
      totalCredAssociado: 0,
      totalFatura: 0,
      relData: {
        fatura: "",
        codsocio: "",
      },
      itemsTop: [],
      itemsCheque: [],
      rentalSel: "",
    };
  },
  filters: {
    filterData(val) {
      return val.replaceAll("/", "-");
    },
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return valor ? formatter.format(valor) : "-";
    },
  },
  props: {
    tipo: String,
    periodo: String,
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  components: {
    TheHeader,
    ItemCard,
    List,
    IconPdf,
    IconXls,
  },
  methods: {
    downloadCSV() {
      // var csvFile;
      // var downloadLink;
      // csvFile = new Blob([csv], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" });
      // downloadLink = document.createElement("a");
      // downloadLink.download = filename;
      // downloadLink.href = window.URL.createObjectURL(csvFile);
      // downloadLink.style.display = "none";
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
    },
    exportTableToCSV(rental) {
      // var csv = [];
      // var rows = document.querySelectorAll("table tr");

      // for (var i = 0; i < rows.length; i++) {
      //   var row = [],
      //     cols = rows[i].querySelectorAll("td, th");

      //   for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);

      //   csv.push(row.join(","));
      // }
      // this.downloadCSV(csv.join("\n"), this.urlParams.tipo + ".xls");
      var el = document.getElementById(rental);
      el.querySelector(".xlsx").click();
    },
    getRelatorio() {
      this.$http
        .get(`/api/CdlBh/RelatorioCheques?AnoMes=${this.urlParams.periodo}`)
        .then((response) => {
          this.relData = response.data;
          this.itemsTop = [
            {
              titulo: "Período",
              valor: this.formatDate(this.urlParams.periodo),
            },
            {
              titulo: "Cheques Depositados",
              valor: response.data.faturamento[0].quantidade,
            },
            // {
            //   titulo: 'Risco Evitado',
            //   valor: response.data.percrisc
            // },
            {
              titulo: "Total",
              valor: "R$ " + response.data.valrisc,
            },
          ];
          this.itemsCheque = [];
        })
        .then(() => {
          this.relData.creditoentidade.forEach((el) => {
            this.totalCredEntidade += el.valor;
          });
          this.relData.creditoassociado.forEach((el) => {
            this.totalCredAssociado += el.valor;
          });
          this.totalFatura = this.totalCredEntidade + this.totalCredAssociado;
        })
        .then(() => {
          tableexport(document.getElementsByTagName("table"));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatDate(date) {
      const ano = date.substr(0, 4);
      const mes = this.getMes(date.substr(5, 2));
      return `${mes} / ${ano}`;
    },
    getMes(mes) {
      const m = parseInt(mes) - 1;
      return this.$store.state.calendarOpts.pt.monthNames[m];
    },
    printPage() {
      const input = document.getElementById("relcontainer");
      const divHeight = input.clientHeight;
      const divWidth = input.clientWidth;
      const ratio = divHeight / divWidth;

      html2canvas(input, { scale: "1", x: "300" }).then((canvas) => {
        let img = canvas.toDataURL("image/png");
        let pdf = new jsPDF("portrait", "mm", "a4");

        const width = pdf.internal.pageSize.getWidth() + 30;
        let height = pdf.internal.pageSize.getHeight();
        height = ratio * width;

        pdf.addImage(img, "JPEG", 0, 0, width, height);
        pdf.save(
          `DemonstrativoFaturamentoUnificado-${this.urlParams.periodo}.pdf`
        );
      });
    },
  },
  created() {
    this.getRelatorio();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

.btn-voltar {
  color: $primary;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}
.title {
  color: $primary;
  font-weight: 700;
  font-size: 24px;
}
.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}
h3.subtitle {
  font-size: 1.5rem;
  font-weight: 700;
  color: #05428e;
}
.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}
.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}
.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
table {
  width: fit-content;
  margin-top: 20px;
}
td {
  font-size: 0.8rem;
}
.rel-block {
  width: 100%;
  border-radius: 5px 0;
  background: #fff;
  margin: 25px 15px 15px 15px;
}
.rel-data {
  justify-content: space-between;
  color: #6c757d;
  .titulo {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    margin-bottom: 20px;
  }
  .item {
    border-top: 2px solid #6c757d;
    padding: 10px 0;
    margin: 0;
    .field {
      padding: 0px !important;
    }
    .value {
      text-align: right;
      padding: 0px !important;
    }
  }
}
.total {
  justify-content: space-between;
  color: #6c757d;
  .item {
    border-top: 2px solid #6c757d;
    padding-top: 30px;
    padding-right: 0px;
    margin: 0;
    .field {
      text-align: right;
    }
    .value {
      text-align: right;
      font-weight: bold;
      font-size: 20px;
      color: #000;
      padding: 0px !important;
    }
  }
}
.first {
  padding-right: 3px !important;
}
.last {
  padding-left: 3px !important;
}
.other {
  padding-right: 3px !important;
  padding-left: 3px !important;
}
</style>
